import { Row, Col, message, Card, Typography, Divider, } from "../ui/ot";
import { Form, } from "antd";
import { useState, useEffect } from "react";
import CommunityForm from "./views/CommunityForm";
import { useWebsiteBasicInformation } from "./controller/WebsiteBasicInformationController";
import QuestionAndAnswer from "../question_and_answer/views/question_and_answer"

const CommunitySetting = ({ prefixTitle = "" }) => {

    const [form] = Form.useForm();
    const [axiosMode, setAxiosMode] = useState("patch");

    const onFormFinish = (values) => {
        console.log({
            values
        })
        if (axiosMode === "post") {
            postWebsiteBasicInformationData([values]);
        } else if (axiosMode === "patch") {
            patchWebsiteBasicInformationData([values]);
        }
    };
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("送出成功");
                // actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.success("修改成功");
                // actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.success("刪除成功");
                // actionRef.current.reloadAndRest();
                // setSelectedRowKeys([])
                // setSelectedRowsInfo([])
            }
            // setModalLoading(false)
            // setModalOpen(false)
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗");
                // actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.error("修改失敗");
                // actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.error("刪除失敗");
                // actionRef.current.reloadAndRest();
            }
            // setModalLoading(false)
            // setModalOpen(false)
        }
    };
    const onBefore = ({ axiosMode, status, values }) => {
        // setModalLoading(true)
    };
    const {
        WebsiteBasicInformationData,
        getWebsiteBasicInformationData,
        postWebsiteBasicInformationData,
        patchWebsiteBasicInformationData,
        communityData,
        getCommunityData,
        // deleteAppointmentData,
    } = useWebsiteBasicInformation({
        onFinish,
        onBefore,
    });

    useEffect(() => {
        WebsiteBasicInformationData.forEach((item) => {
            form.setFieldsValue(item);
        });
    }, [WebsiteBasicInformationData]);
    useEffect(() => {
        document.title = `${prefixTitle} | 網站設定`;

        getWebsiteBasicInformationData();
        getCommunityData();
    }, []);

    return (
        <Row gutter={[8, 8]}>
            <Col span={24}>
                <Typography.Title
                    level={3}
                >
                    網站社群設定
                </Typography.Title>
                <CommunityForm
                    propsForm={form}
                    onFormFinish={onFormFinish}
                    selectOption={communityData}
                ></CommunityForm>
            </Col>
            <Col span={24}>
                <Divider />
            </Col>
            <Col span={24}>
                <QuestionAndAnswer />
            </Col>
        </Row>
    );
};
export default CommunitySetting;
